<div class="title-section">
  <strong class="primary-text pueblo-font display-large">{{ title }}</strong>
</div>

<div class="intro-animation-container">
  <div class="interest-item">
    <div class="interest-item-content" #interestItem1>
      <div class="emoji">{{ $interestItem1Value().emoji }}</div>
      <div class="interest-name title-medium">
        {{ $interestItem1Value().name }}
      </div>
    </div>
  </div>
  <div class="interest-item">
    <div class="interest-item-content" #interestItem2>
      <div class="emoji">{{ $interestItem2Value().emoji }}</div>
      <div class="interest-name title-medium">
        {{ $interestItem2Value().name }}
      </div>
    </div>
  </div>

  @for (user of users; track $index) {
    <div
      class="user-item"
      [style.transform]="
        'translate(-50%, -50%) rotate(' + user.index * 45 + 'deg)'
      "
      [attr.data-index]="user.index"
      #userItem
    >
      <div
        class="user-avatar"
        [style.transform]="'rotate(-' + user.index * 45 + 'deg)'"
      >
        <user-avatar
          [avatar]="user.avatarUrl"
          [displayName]="'Unknown'"
          [color]="DEFAULT_COLOR"
          [size]="50"
          [selected]="false"
        ></user-avatar>
      </div>
      <div class="line"></div>
    </div>
  }
</div>

<div class="intro-text">
  <div class="title-large">Turn solo plans into shared hangs</div>
</div>

<div class="body-medium">
  Join <strong>Pueblos</strong>, post <strong>Hangs</strong>, and tag
  <strong>Interests</strong> so the right friends can join — no pressure, no
  planning.
</div>
